import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CampaignChoicePage as CampaignChoiceComponent } from '@/components/campaign/CampaignChoicePage';

export const CampaignChoicePage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get campaign name from state or localStorage
  const campaignName = location.state?.campaignName || localStorage.getItem('campaignName');

  const handleManualChoice = () => {
    // Navigate to manual campaign creation
    navigate('/campaign/create');
  };

  const handleAIChoice = () => {
    // This will be handled by the component itself (showing AI assistant)
    console.log('AI choice selected');
  };

  return (
    <CampaignChoiceComponent
      campaignName={campaignName}
      onManualChoice={handleManualChoice}
      onAIChoice={handleAIChoice}
    />
  );
};

export default CampaignChoicePage;